var chunkMapping = {
	"411": [
		2792
	],
	"564": [
		22564
	],
	"880": [
		73880
	]
};
var idToExternalAndNameMapping = {
	"2792": [
		"default",
		"./JobsModule",
		77995
	],
	"22564": [
		"default",
		"./module",
		78145
	],
	"73880": [
		"default",
		"./ClaimsModule",
		33407
	]
};
var idToRemoteMap = {
	"2792": [
		{
			"externalType": "script",
			"name": "jobManagement"
		}
	],
	"22564": [
		{
			"externalType": "script",
			"name": "spclaims_management"
		}
	],
	"73880": [
		{
			"externalType": "script",
			"name": "claimManagement"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"2792": {
		"shareScope": "default",
		"name": "./JobsModule",
		"externalModuleId": 77995,
		"remoteName": "jobManagement"
	},
	"22564": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 78145,
		"remoteName": "spclaims_management"
	},
	"73880": {
		"shareScope": "default",
		"name": "./ClaimsModule",
		"externalModuleId": 33407,
		"remoteName": "claimManagement"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}